import React from "react";
import BlogCard from "components/Blogs/BlogCard";

const BlogList = ({ blogs, ...props }) => {
  return (
    <div className="container mx-auto">
      <div className="grid lg:grid-cols-4 md:grid-cols-3 gap-10 grid-cols-1 mx-8">
        {blogs.map((blog, idx) => {
          return (
            <div className="">
              <BlogCard blog={blog} />
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default BlogList;
